<template>
	<button @click="toggleTooltip" class="relative group w-8 h-8 rounded flex justify-center items-center bg-complementary-900 ">
		<span class="material-symbols-rounded text-complementary-300 text-lg">live_help</span>
		<tooltip-hayadata v-if="showTooltip" :positionBottom="true" class="!absolute left-[-200px] xl:left-[-32px] bottom-[49px]"></tooltip-hayadata>
	</button>
</template>

<script>

export default {
	name: "button-tooltip-icon-hayadata",
	data() {
			return {
				showTooltip: false
			};
		},
	methods: {
		toggleTooltip() {
			this.showTooltip = !this.showTooltip;
			if (this.showTooltip) {
				document.addEventListener("click", this.hideTooltipOutside);
			} else {
				document.removeEventListener("click", this.hideTooltipOutside);
			}
		},
		hideTooltipOutside(event) {
			if (!this.$el.contains(event.target)) {
				this.showTooltip = false;
				document.removeEventListener("click", this.hideTooltipOutside);
			}
		}
	}
}
</script>

<style>

</style>